import React from 'react';

import './Mera.css';

const mera = props => (
  <div className="column-container mera">
    <div className="compact">
      <h3>Mera</h3>

      <h4>Undersökningar</h4>
      <p>För att möta våra kunders krav, kvalitetskontroll och önskningar genomför vi kontinuerligt marknadsundersökningar. Genom att svara på dessa deltar Du i projektet och svar gengäldas alltid med
        en gåva. Aktuell undersökning finns i Access Kungaskogen. Ibland kan den också skickas med mail till slumpmässigt utvalda användare.</p>

      <h4>Copyright</h4>
      <p>All Copyright finns hos förlagen ILKA Förlagsprodukter AB och Wasa Music AB som äger alla rättigheter till ”Snack & Snack Vännerna i Kungaskogen”.</p>

      <h4>Arrangörer Barn</h4>
      <p>Arrangörer (barnteater, events, familjeaktiviteter, barnkalas, projekt) kan alltid vända sig till förlaget för offert på uppträdande med dialog, sång, användande av varumärken i Kungaskogen, musik mm.</p>

      <h4>Utländsk marknad</h4>
      <p>Förlaget arbetar med att etablera koncept och IP ”Vännerna i Kungaskogen” på utländska marknader. Vi ser med intresse fram emot kontakter på andra marknader och vi är övertygade om att
        den succé som finns i Sverige kan överföras till andra länder och marknader.</p>

      <h4>Feedback</h4>
      <p>Vi tar gärna emot synpunkter på projektet Vännerna i Kungaskogen och uppbyggnad och info på denna hemsida.</p>
    </div>
  </div>

);

export default mera;
